declare global {
  interface Window {
    zE: any;
  }
}

interface Agent {
  isAgent?: boolean;
  isEmployee?: boolean;
  email: string;
  firstName: string;
  lastName: string;
  customerId?: number;
  customerAgents?: [];
}

interface SupportFormOffset {
  horizontal?: string;
  vertical?: string;
}

/**
 * this activates zendesk form and make it visible, also prefills name and email of the logged in session if agent data is provided
 * @param sidebarExpanded boolean param for whether sidebar is expanded or not
 * @param agent this is an object of the agent data, must include firstName, lastName, and email.
 */

export const openZendeskSupportForm = (
  sidebarExpanded: boolean,
  agent: Agent,
  offsetOverride?: SupportFormOffset,
  positionOverride?: SupportFormOffset,
) => {
  const { firstName, lastName, email } = agent;
  if (window.zE) {
    window.zE(() => {
      if (agent?.email) {
        window.zE('webWidget', 'prefill', {
          name: {
            value: `${firstName} ${lastName}`,
            readOnly: true,
          },
          email: {
            value: email,
            readOnly: true,
          },
        });
      } else {
        window.zE('webWidget', 'prefill', {
          name: {
            readOnly: false,
          },
          email: {
            readOnly: false,
          },
        });
      }

      window.zE('webWidget', 'updateSettings',
        {
          offset: offsetOverride || {
            horizontal: sidebarExpanded ? '233px' : '85px',
          },
          position: positionOverride || { horizontal: 'left', vertical: 'bottom' },
          answerBot: {
            suppress: false,
            contactOnlyAfterQuery: true,
          },
          contactOptions: {
            contactFormLabel: { '*': 'Contact Support' },
            contactButton: { '*': 'Contact Support' },
          },
        },
      );

      window.zE.activate();
    });
  }
};

export default {
  openZendeskSupportForm,
};
